import { all, call, put } from 'redux-saga/effects';

import { getFilingPeriodList, getRegFilingTypesList } from '@api/filingTypes';
import { filingTypesGetModel } from '@models/filingTypes';
import {
  filingTypesFetchFailure,
  filingTypesFetchSuccess,
} from '@store/entityJurisdictions/entityJurisdictionsDetail/filingTypes/filingTypes.reducer';
import { toastError } from '@store/notifications';

export const filingTypesFetchSaga = function* ({ payload }) {
  try {
    const [filingResponse, periodResponse] = yield all([
      call(getRegFilingTypesList, payload.entityJurisdictionId),
      call(getFilingPeriodList, payload.entityJurisdictionId),
    ]);

    yield put(
      filingTypesFetchSuccess(
        filingTypesGetModel(filingResponse?.results || [], periodResponse?.userExperiences)
      )
    );
  } catch (error) {
    const { nonFieldErrors, hasNonFieldError } = error.data || {};

    yield put([
      toastError({
        message: hasNonFieldError
          ? nonFieldErrors
          : {
              defaultMessage: 'Failed to fetch filing types.',
              id: 'pages.registrations.filing-types-fetch.notification.error',
            },
      }),
      filingTypesFetchFailure(),
    ]);
  }
};
